/**
 * Enum controlling the underline behavior of links or text elements.
 */
export enum UnderLineType {
  None = 'none',
  OnHover = 'onHover',
  Underline = 'underline'
}
